import(/* webpackMode: "eager" */ "/app/src/app/(landing-page)/(static-pages)/faqs/page.tsx")